import script from "./ActionColumn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionColumn.vue?vue&type=script&lang=ts&setup=true"

import "./ActionColumn.vue?vue&type=style&index=0&id=657c5e98&lang=css"

const __exports__ = script;

export default __exports__